import { makeStyles } from '@mui/styles'

export default makeStyles(() => ({
  table: {
    boxShadow: '0 0px 0px 0 rgba(0, 0, 0, 0)',
  },
}))
